export enum ComponentType {
  ACCORDION = 'accordion',
  ADYEN_PAYMENT_WIDGET = 'adyen_payment_widget',
  CARD = 'card',
  CAROUSEL = 'carousel',
  CART = 'cart',
  CHAT = 'chat',
  CHECKOUT = 'checkout',
  CTA = 'cta',
  CUSTOM = 'custom',
  FILTER = 'filter',
  FILTER_SORT_MODAL = 'filter_sort_modal',
  FOOTER = 'footer',
  FORM = 'form',
  GALLERY = 'gallery',
  ITEM = 'item',
  ITEM_LIST = 'item_list',
  MAP = 'map',
  MAP_MODAL = 'map_modal',
  MENU = 'menu',
  MODAL = 'modal',
  PAGINATION = 'pagination',
  PROMOTION_CODE = 'promotion_code',
  PROMOTION_LIST = 'promotion_list',
  SEARCH = 'search',
  SEARCH_ERROR = 'search_error',
  SEARCH_PANEL = 'search_panel',
  SEARCH_RESULTS = 'search_results',
  SORT = 'sort',
  TAB = 'tab',
  TILE = 'tile',
  TOOLTIP = 'tooltip',
}
